import { createFileRoute } from '@tanstack/react-router';
import { WithholdingSlipProfileRegistryPage } from './-components/WithholdingSlipProfileRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/withholding-slips/')({
  component: WithholdingSlipProfileRegistryPage
});